import React from 'react';
import ReactDOM from 'react-dom';
import moment from 'moment';
import Header from 'components/layout/header';
import LoadingButton from 'components/loadingBtn';
import {calibration} from 'helpers/scanHelpers';
import events from 'lib/events';
import router from 'lib/router';
import routeUtils from 'util/routeUtils';
import Loader from 'components/loader';
import session from 'services/sessionService';
import IntlWrapper from 'components/layout/intlWrapper';
import {FormattedMessage, FormattedHTMLMessage, intlShape, injectIntl} from 'react-intl';
import TC from 'services/testConnect2p0';

// imports necessary to support socket scanning interface
import {old_render} from 'page/tools/calibration.jsx';
import {UseHTTPScannerInterface} from "lib/globals";

let old_or_new_render = (container) => {
  UseHTTPScannerInterface.then((val) => {
    if(val===true){
      render(container);
    }else{
      old_render(container);
    }
  });
}

let render = container => {
  console.info('[UI.page.tools.calibration] rendering page');
  ReactDOM.render(<IntlWrapper><WrapperCalibration/></IntlWrapper>, container);
  events.publish('page-change', {page: 'tools'});
};

console.info('[UI.page.tools.calibration] register route');
router.rr.add([{path: 'tools/calibration', handler: routeUtils.requireAuth(old_or_new_render)}]);

class Calibration extends React.Component {
  static propTypes = {
    intl: intlShape.isRequired,
  };

  static displayName = 'Calibration';

  state = {
    ccDate: null,
    scannerInitialized: false,
    isScanning: false,

    smartlabConnected: false,
    smartlabStarted: false,
  };

  componentDidMount() {
    this.initializeScanner();
    this.titrationTestingListener = events.subscribe('dealeruser.toggleTitrationTestingOnly', () => this.initializeScanner());
  }

  componentWillUnmount() {
    if (this.titrationTestingListener && this.titrationTestingListener.remove) {
      this.titrationTestingListener.remove();
    }

    if (this._scanCompleteListener && this._scanCompleteListener.remove) {
      this._scanCompleteListener.remove();
    }

    if (this._scanCancelSub && this._scanCancelSub.remove) {
      this._scanCancelSub.remove();
    }
  }

  handleScannerData = data => {
    this.setState(Object.assign(this.state, data, {isScanning: false}));
  };

  initializeScanner = () => {
    if (!session.getUser().titrationTestingOnly) {
      TC.getStatus()
        .then(data => {
          if (!data || !data.scanners) {
            this.setState({
              scannerInitialized: true,
              smartlabConnected: false,
            });
            return;
          }

          this._scanCompleteListener = events.subscribe('scanner.complete', (data) => {
            this.handleScannerData(data);
            TC.reset(!session.getUser().titrationTestingOnly);
          });

          this._scanCancelSub = events.subscribe('scanner.cancel', () => {
              this.setState({isScanning: false});
          });

          this.setState({
            isScanning: TC.isScanning,
            smartlabStarted: TC.isScanning,
            scannerInitialized: true,
            smartlabConnected: data.scanners.includes('SmartLab 1') || data.scanners.includes('SmartLab 2'),
            ccDate: moment(data.tc_last_calibration_date),
          });
        })
        .catch(err => {
          console.error(err);
          this.setState({
            scannerInitialized: true,
            smartlabConnected: false,
          });
        });
    } else {
      this.setState({
        scannerInitialized: true,
        smartlabConnected: false,
      });
    }
  };

  smartlabFields = () => {
    if (!this.state.smartlabStarted) {
      return null;
    }

    return <table className='table-biolab table-striped'>
      <thead>
        <tr>
          <th><FormattedMessage id="tools.calibration.field"/></th>
          <th><FormattedMessage id="tools.calibration.calibration.results"/></th>
        </tr>
      </thead>
      <tbody>
        {calibration.chlorine.map(row =>
          <tr key={row.name}>
            <td><FormattedMessage id={row.name} /></td>
            <td>{this.state[row.field] || '-'}</td>
          </tr>)}
      </tbody>
    </table>;
  };

  smartlabInstructions = () => {
    const {formatMessage} = this.props.intl;

    if (!this.state.smartlabConnected) {
      return <p><FormattedMessage id='tools.calibration.smartlab.connect' /></p>;
    }

    return <div>
      <ol>
        <li>
          <FormattedMessage id='tools.calibration.instructions.step1' values={{
            disk: <i>{formatMessage({id: 'tools.calibration.check-disk'})}</i>,
            not: <strong>{formatMessage({id: 'tools.calibration.do.not'})}</strong>,
          }} />
        </li>
        <li>
          <FormattedMessage id='tools.calibration.instructions.step2' values={{
            disk: <i>{formatMessage({id: 'tools.calibration.check-disk'})}</i>,
          }} />
        </li>
        <li>
          <FormattedMessage id='tools.calibration.instructions.step3' values={{
            buttonName: <i>{formatMessage({id: 'general.start.scan'})}</i>,
          }} />
        </li>
        <li>
          <FormattedMessage id='tools.calibration.instructions.step4' values={{
            disk: <i>{formatMessage({id: 'tools.calibration.check-disk'})}</i>,
          }} />
        </li>
      </ol>
      <p>
        <LoadingButton
          className='btn btn-primary'
          onClick={this.smartlabStartScan}
          loading={this.state.isScanning}
          disabled={this.state.isScanning}>
          <FormattedMessage id="tools.start.calibration"/>
        </LoadingButton>
      </p>
      {this.smartlabFields()}
      <br/>
    </div>;
  };

  smartlabStartScan = () => {
    TC.startSmartLabCalibration();
    this.setState({smartlabStarted: true, isScanning: true});
  };

  render() {
    if (this.state.securityError) {
      return <div className='container'>
        <h3><FormattedMessage id="tools.calibration.complete.test"/></h3>
        <br/>
        <p><a className='btn btn-default'
              href='#support/ie-security-error'><FormattedMessage id="general.click.troubleshoot"/></a></p>
      </div>;
    }

    return <div className='calibration-page container'>
      <Header mainTitle={this.props.intl.formatMessage({id: 'tools.title'})}
              subTitle={this.props.intl.formatMessage({id: 'general.calibration'})}
              fallbackMainTitleReturn='tools'/>
      <div className='row'>
        <Loader loaded={this.state.scannerInitialized}>
          <div className='container'>
            <h2>Smart Lab 1<sup>&#8482;</sup> <FormattedMessage id="general.calibration"/></h2>
            <div className='col-sm-12'>
              {this.smartlabInstructions()}
            </div>
          </div>
          <hr/>
        </Loader>
      </div>
    </div>;
  }
}

const WrapperCalibration = injectIntl(Calibration);

export default WrapperCalibration;
